export default "__VITE_ASSET__LP81$Gx$__"